var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.chapterButtons
    ? _c("chapter-button", {
        attrs: {
          type: "next",
          disabled: _vm.nextChapterDisabled,
          color: _vm.color,
          title: _vm.$t(_vm.title.key, _vm.title.attr),
          "data-test": "chapter-next"
        },
        on: { click: _vm.dispatch }
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }